import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Lots_ds_get_vendorlot_by_vendorlotIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { vendorLotId: number }): 
  Promise<{ result: { Id?: number, Description?: string, ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string, MaterialId?: number, Notes?: string, Vat?: string } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.vendorLotId)) {
      missingRequiredInParams.push('\'vendorLotId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Lots/datasources/ds_get_vendorlot_by_vendorlotId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      vendorLotId: number    }) {
        if(isNil(inParams.vendorLotId)) {
          return true; 
        }
      return false;
    }
}
